import { generateMockId } from '@gp/utils/common';

import type {
  IProjectGRActionItem,
  IProjectGRActionItemProjectDTO,
  IProjectGRActionItemProjectVO,
} from '@gp/types/grActionItems';

export const getProjectActionItemKey = (cvm: IProjectGRActionItemProjectVO): string => {
  const { project_id: projectId, due_date: dueDate, action_content: actionContent } = cvm || {};
  return `${projectId}_${dueDate}_${actionContent}`;
};

const buildGRActionItem = (data?: IProjectGRActionItem | null): IProjectGRActionItem => {
  const {
    id,
    action_content: actionContent,
    due_date: dueDate,
    state,
    state_comment: stateComment,
    user,
  } = data || {};
  return {
    id: generateMockId(id) || '',
    action_content: actionContent || '',
    due_date: dueDate || '',
    state: state || '',
    state_comment: stateComment || '',
    user: user || '',
  };
};

const analysisIndexRows = (list?: number[]): number[] => {
  if (!Array.isArray(list) || !list.length) return [];
  return list.flatMap((item) => {
    if (item === 1) return item;
    const rest = item - 1;
    return [item, ...Array.from({ length: rest }).fill(0)] as number[];
  });
};

export const analysisProjectGRActionItems = (
  list?: IProjectGRActionItemProjectDTO[] | null,
): {
  records: IProjectGRActionItemProjectVO[];
  rowSpans: number[];
} => {
  if (!Array.isArray(list) || !list.length) return { records: [], rowSpans: [] };
  const result: IProjectGRActionItemProjectVO[] = [];
  const resultIndexRows: number[] = [];
  for (const item of list) {
    const { gr_action_items: grActionItems, ...restItem } = item || {};
    if (!Array.isArray(grActionItems) || !grActionItems.length) {
      result.push({ ...restItem, ...buildGRActionItem(null) });
      resultIndexRows.push(1);
      continue;
    }

    for (const grActionItem of grActionItems) {
      result.push({ ...restItem, ...buildGRActionItem(grActionItem) });
    }
    resultIndexRows.push(grActionItems.length);
  }

  return {
    records: result,
    rowSpans: analysisIndexRows(resultIndexRows),
  };
};
